import { ListingKind, ListingType } from '@ha/api/v2/types/Listing';
import { TypeValue } from 'ha/types/SearchFilters';

export function getCategory(kind: number, type: number): string {
  switch (kind) {
    case ListingKind.PrivateRoom:
      return TypeValue.PRIVATE_ROOM;
    case ListingKind.SharedRoom:
      return TypeValue.SHARED_ROOM;
    default:
      if (type === ListingType.Apartment) {
        return TypeValue.APARTMENT;
      }
  }

  return '';
}
